import { FolderZipIcon } from './FolderZipIcon';

/**
 * author: Michael Irigoyen
 * id 1573C575-7FBA-4BCD-A960-02D42043FE6F
 * name folder-zip
 * version: 1.8.36
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/folder-zip.svg
 * tags
 * - Files / Folders 
 */
export const CompressedFolderIcon = FolderZipIcon;
export default CompressedFolderIcon